<template>
	<div
		:class="
			'conversation-list-item card ' +
				(!dropdownActive ? 'hovershadow ' : '') +
				(active ? 'active secondary ' : '')
		"
		@click="handleClick"
		@contextmenu.exact.prevent="dropdownActive = true"
	>
		<div class="conversation-avatar-container">
			<ConversationAvatar
				v-if="
					conversationProviderHasAvatarProvider(
						conversation.providerName
					)
				"
				:providerName="conversation.providerName"
				:conversationId="conversation.id"
				class="flat rounded shadow lg"
				:key="
					conversation.id
						? 'conversation_' +
						  conversation.providerName +
						  '_' +
						  conversation.id
						: 'conversation_' + conversation.providerName
				"
			/>
			<button
				v-else
				class="conversation-avatar btn action flat rounded"
			></button>
		</div>
		<div class="content">
			<span class="title_timestamp_conversation-action-dropdown">
				<span class="title clr-secondary"
					>{{ conversation.name }}
					<i v-if="!oneProviderMode"
						>({{ conversation.providerName }})</i
					></span
				>
				<span class="timestamp"
					>{{
						conversation.lastMessage &&
						conversation.lastMessage.dateAdded
							? '&nbsp;' + timestamp
							: ''
					}}&nbsp;</span
				>
				<Dropdown
					v-if="getConversationListItemActions"
					class="conversation-action-dropdown"
					:items="getConversationListItemActions"
					align="right"
					@update:active="dropdownActive = $event"
					:active="dropdownActive"
				>
					<template v-slot:activator="scope">
						<button
							:class="
								'conversation-action-btn btn action link sm ' +
									(scope.active ? 'active ' : '')
							"
							@click.stop="scope.on()"
						>
							<icon>dots-vertical</icon>
						</button>
					</template>
					<template v-slot:item="scope">
						<button
							:class="
								'conversation-action-dropdown-menu-li btn ' +
									(scope.item.classes || 'link')
							"
							@click.stop="dropdownAction(scope)"
							:disabled="scope.item.disabled"
						>
							{{
								typeof scope.item.name === 'function'
									? scope.item.name()
									: scope.item.name
							}}
						</button>
					</template>
				</Dropdown>
			</span>
			<span class="last-message">
				<span class="username">{{
					conversation.lastMessage && conversation.lastMessage.userId
						? (conversation.lastMessage.userName ||
								conversation.lastMessage.userId) + ':&nbsp;'
						: ''
				}}</span>
				<span class="body">{{
					conversation.lastMessage &&
					decodeURIComponent(conversation.lastMessage.body)
						? decodeURIComponent(conversation.lastMessage.body)
						: ''
				}}</span>
			</span>
		</div>
	</div>
</template>

<script>
import Icon from './Icon';
import Dropdown from './Dropdown';
import ConversationAvatar from './ConversationAvatar.vue';
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
	name: 'ConversationListItem',
	components: {
		Icon,
		Dropdown,
		ConversationAvatar
	},
	props: ['conversation', 'active'],
	data() {
		return {
			dropdownActive: false,
			lastId: null
		};
	},
	computed: {
		curdate() {
			return moment().format('MMMM Do, YYYY');
		},
		timestamp() {
			if (this.conversation.lastMessage) {
				let msgdate = moment(
					this.conversation.lastMessage.dateAdded,
					'x'
				).format('MMMM Do, YYYY');
				return this.curdate === msgdate
					? moment(
							this.conversation.lastMessage.dateAdded,
							'x'
					  ).format('HH:mm')
					: moment(msgdate, 'MMMM Do, YYYY')
							.subtract(1, 'd')
							.format('MMMM Do, YYYY') === this.curdate
					? 'Yesterday'
					: moment(msgdate, 'MMMM Do, YYYY').format('M/D/Y');
				// return moment(conversation.lastMessage.dateAdded, "x").fromNow();
			}
			return '';
		},
		getConversationListItemActions() {
			if (!this.conversation) return null;

			const actionsGetter = this.$store.getters[
				'ConversationProviders/provider_' +
					this.conversation.providerName +
					'/conversationListItemActions'
			];

			if (!actionsGetter) return null;

			const actions = actionsGetter(this.conversation.id, {
				commit: this.$store.commit,
				dispatch: this.$store.dispatch
			});
			if (!actions) return null;

			actions.unshift({
				name:
					(this.conversation.name || this.conversation.id) +
					(!this.oneProviderMode
						? ' (' + this.conversation.providerName + ')'
						: ''),
				disabled: true
			});
			actions.push({
				name: 'Close'
			});

			return actions;
		},
		...mapGetters({
			oneProviderMode: 'ConversationProviders/oneProviderMode'
		})
	},
	methods: {
		handleClick() {
			if (this.active) {
				this.closeConversationInfo();
				this.closeConversation();
			} else {
				this.openConversation([
					this.conversation.providerName,
					this.conversation.id
				]);
			}
		},
		conversationProviderHasAvatarProvider(providerName) {
			return this.$store.getters[
				'ConversationProviders/provider_' +
					providerName +
					'/getConversationAvatar'
			];
		},
		closeConversationInfo() {
			this.$emit('update:conversationInfoOpen', false);
		},
		dropdownAction(scope) {
			if (!scope.item.keepOpen) scope.on();
			this.$nextTick(() => {
				if (scope.item.onclick) scope.item.onclick();
			});
		},
		...mapActions(['openConversation', 'closeConversation', 'newMsg'])
	},
	watch: {
		'conversation.lastMessage'(newval, oldval) {
			if (newval && newval.key !== this.lastKey) {
				this.lastKey = newval.key;

				// Send new message event to plugins
				this.newMsg([this.conversation, newval]);
			} else if (!newval) {
				this.lastKey = null;
			}
		}
	}
};
</script>
